"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
class Logger {
    constructor(service) {
        this.name = service;
    }
    _log(color, method, args) {
        const origin = `%c[${this.name}](${method})`;
        const css = `background: #${color}`;
        if (args.length === 0) {
            console.log(origin, css);
        }
        else if (args.every((arg) => typeof arg === 'string')) {
            console.log(`${origin}:`, css, args.join(' '));
        }
        else {
            console.log(`${origin}:`, css, args);
        }
    }
    log(method, ...args) {
        this._log('d3ffcf', method, args);
    }
    warn(method, ...args) {
        this._log('fff4cf', method, args);
    }
    error(method, ...args) {
        this._log('ffcfcf', method, args);
    }
}
exports.Logger = Logger;
//# sourceMappingURL=Logger.js.map